// Translations
import generalInformation from '../sections/general-information/translations/ru'
import networks from '../sections/networks/translations/ru'
import specialties from '../sections/specialties/translations/ru'

// Translation: Account > Profile (Russian)
export default Object.freeze({
	header: {
		controls: {
			save: ''
		},
		subtitle: '',
		title: {
			personalProfile: '',
			teamProfile: ''
		}
	},
	sections: { generalInformation, networks, specialties }
})
